import { useEffect } from 'react'
import { useRouter } from 'next/router'
import * as fbq from '@/services/fbpixel'

export const useFacebookPixel = () => {
  const router = useRouter()

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      fbq.pageview()

      const handleRouteChange = () => {
        fbq.pageview()
      }

      router.events.on('routeChangeComplete', handleRouteChange)
      return () => {
        router.events.off('routeChangeComplete', handleRouteChange)
      }
    }
  }, [router.events])
} 